<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{ completed: number; total: number }>()

const ratio = computed(() => {
  if (props.total <= 0) return 0
  return Math.min(1, Math.max(0, props.completed / props.total))
})
</script>

<template>
  <div
    class="bar"
    role="progressbar"
    :aria-valuenow="ratio * 100"
    aria-valuemin="0"
    aria-valuemax="100"
  >
    <div class="fill" :style="{ width: `${ratio * 100}%` }" />
  </div>
</template>

<style scoped>
.bar {
  height: 10px;
  border-radius: 999px;
  background: var(--pl-color-border-subtle, #e2e8f0);
  border: 1px solid var(--pl-color-border-subtle, #e2e8f0);
  overflow: hidden;
}

.fill {
  height: 100%;
  background: var(--pl-color-primary, #4338ca);
}
</style>
